<template>
  <div>
    <header class="header header--mobile">
      <div class="header-mobile__wrapper">
        <div class="nav-logo__container flex">
          <a v-if="isGeneric" href="/"
            ><img src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity logo" class="nav-logomark" />
          </a>
          <img v-else src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity logo" class="nav-logomark" />
          <img
            v-if="logoImageUrl && !imageBroken"
            :src="logoImageUrl"
            :alt="`${corporateClientName} logo`"
            class="nav-corporate-client-logo"
            @error="hideImage"
          />
        </div>
        <a href="https://support.sittercity.com/" class="nav-navigation__link ml-auto mr-2 corporate-nav-link">Help</a>
        <Button value="Log In" variant="outlined" size="small" class="mr-8 md:mr-32" @click="toggleVisibility" />
      </div>
      <corporate-header-dropdown v-if="dropdownVisible" :slug="slug" />
    </header>

    <header class="corporate-header header header--desktop row">
      <div class="nav-logo__container col m2 flex">
        <a v-if="isGeneric" href="/">
          <SittercityLogo />
        </a>
        <img v-else src="@/images/components/header/sittercity-full-logo.svg" alt="Sittercity logo" class="w-[153px]" />
        <img
          v-if="logoImageUrl && !imageBroken && slug !== 'benefits'"
          :src="logoImageUrl"
          :alt="`${corporateClientName} logo`"
          class="nav-corporate-client-logo"
          @error="hideImage"
        />
      </div>
      <nav class="nav-navigation m6 push-m4" role="navigation">
        <ul class="nav-navigation__list">
          <li class="nav-navigation__item">
            <a href="https://support.sittercity.com/" class="nav-navigation__link">Help</a>
          </li>
          <li class="nav-navigation__item">
            <Button value="Log In" variant="outlined" size="small" class="mr-32" @click="toggleVisibility" />
          </li>
        </ul>
      </nav>
      <corporate-header-dropdown v-if="dropdownVisible" :slug="slug" />
    </header>
  </div>
</template>

<script lang="ts">
import CorporateHeaderDropdown from './CorporateHeaderDropdown.vue';
import Button from '@/components/button/Button.vue';
import SittercityLogo from '@/graphics/logos/SittercityLogo.vue';

export default {
  name: 'CorporateHeader',
  components: { CorporateHeaderDropdown, Button, SittercityLogo },
  props: {
    slug: String,
    logoImageUrl: String,
    corporateClientName: String,
  },
  data(): any {
    return {
      dropdownVisible: false,
      imageBroken: false,
    };
  },
  computed: {
    isGeneric(): Boolean {
      return !this.corporateClientName;
    },
  },
  mounted() {
    // Close modal with 'esc' key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.dropdownVisible = false;
      }
    });
  },
  methods: {
    toggleVisibility(): void {
      this.dropdownVisible = !this.dropdownVisible;
    },
    hideImage(): void {
      this.imageBroken = true;
    },
  },
};
</script>
